import type { DeliveryMethod, DeliveryMethodType, Product, ProductApiResponse } from '@libs/common-types';

function isPurchaseOptionAvailable(
    method: DeliveryMethod | Pick<DeliveryMethod, 'availablePurchaseOptions'> | undefined
): boolean {
    const opts = method?.availablePurchaseOptions;
    if (!opts) return false;
    return opts.oneTime || opts.autoship;
}

function getProductDeliveryMethodsList(deliveryMethods: Product['deliveryMethods'] | undefined): DeliveryMethodType[] {
    if (!deliveryMethods) return [];

    return (Object.entries(deliveryMethods) as [DeliveryMethodType, DeliveryMethod][])
        .reduce<DeliveryMethodType[]>((acc, [methodName, methodData]) => {
            if (isPurchaseOptionAvailable(methodData)) acc.push(methodName);
            return acc;
        }, [])
        .sort((a, b) => a.localeCompare(b));
}

export function getDeliveryMethodsList(productData: ProductApiResponse['data']): DeliveryMethodType[] {
    return [
        ...new Set(
            Object.values(productData.variants).flatMap(product =>
                getProductDeliveryMethodsList(product.deliveryMethods)
            )
        ),
    ].sort((first, second) => first.localeCompare(second));
}
